import React from 'react';
import PropTypes from 'prop-types';
const ValidateField = ({
    input,
    label,
    type,
    meta: { touched, error }
}) => (
        <div>
            <label>{label}</label>
            <div className={touched && error ? "error" : ""}>
                <input {...input} type={type} placeholder={label} />
                {touched && error && <span className="error-text">{error}</span>}
            </div>
        </div>
    );

ValidateField.propTypes = {
    input: PropTypes.object,
    label: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.object
};

export default ValidateField;


// WEBPACK FOOTER //
// ./src/components/ValidateField.jsx